/*
 * File: 客户模块-客户系-详情
 */
<template>
    <div class="customer-series-detail-page">
        <div class="customer-series-head-box">
            <div class="customer-series-head">{{ detailDataLocal.customerGroupName }}</div>
        </div>
        <!-- 表单区域 -->
        <collapse-infos
            class="infos-content customer-series-content-detail"
            ref="collapseInfosRef"
            :key="collapseKeys"
            :detailData="detailDataLocal"
            :collapse="config"
            :activeCollapses="activeCollapses"
        />
        <!-- 子页签组件 -->
        <el-tabs v-model="activeName" @tab-click="handleClickTab">
            <el-tab-pane label="客户明细" name="customerDetail">
                <customer-detail ref="customerDetailRef" :activeName="activeName" :detailData="detailDataLocal" />
            </el-tab-pane>
            <el-tab-pane label="属地客户经理" name="localCustomerManager">
                <local-customer-manager
                    ref="localCustomerManagerRef"
                    :activeName="activeName"
                    :detailData="detailDataLocal"
                    type="customerSeries"
                />
            </el-tab-pane>
            <el-tab-pane label="变更日志" name="history">
                <history ref="historyRef" :activeName="activeName" :detailData="detailDataLocal" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { ref, reactive, computed, watch } from '@vue/composition-api';
import collapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import { collapse } from './config.js';
import customerDetail from './components/customerDetail/Index.vue';
import localCustomerManager from './components/localCustomerManager/Index.vue';
import history from './components/history/Index.vue';

export default {
    name: 'detailPage',
    components: {
        collapseInfos,
        customerDetail,
        localCustomerManager,
        history
    },
    props: {
        detailData: {
            type: Object,
            default() {
                return {};
            }
        }

    },
    setup(props, setupContext) {
        const config = reactive(collapse);
        const activeCollapses = ref(['baseInfo', 'onePagerInfo', 'systemInfo']);
        const detailDataLocal = ref({});
        const collapseKeys = computed(() => {
            return config.filter(it => it.visible).length;
        });
        const activeName = ref('customerDetail');

        const handleClickTab = (data) => {
            const editTabArr = ['localCustomerManager'];
            if (editTabArr.includes(data.name)) { // 解决切换编辑表格时操作列错位问题
                setupContext.root.$nextTick(() => {
                    const tableRef = setupContext.refs[`${data.name}Ref`].$refs.editTableBox;
                    if (tableRef) {
                        tableRef.$refs.moduleTable.doLayout();
                        // 滚动到页面底部
                        setupContext.refs[`${data.name}Ref`].handleToBottom();
                    }
                });
            }
        };

        watch(
            () => props.detailData,
            (val) => {
                activeName.value = 'customerDetail';
                detailDataLocal.value = val;
                setupContext.root.$nextTick(() => {
                    setupContext.refs.collapseInfosRef && setupContext.refs.collapseInfosRef.clearValidate(); // 重置校验报错
                    setupContext.refs.collapseInfosRef && setupContext.refs.collapseInfosRef.refleshPage(val); // 刷新表单子组件
                    setupContext.refs.collapseInfosRef && setupContext.refs.collapseInfosRef.updataInitData(val);
                });
            },
            { deep: true, immediate: true }
        );
        return {
            config,
            collapseKeys,
            activeCollapses,
            detailDataLocal,
            activeName,
            handleClickTab
        };
    }
};
</script>

<style lang="less" scoped>
.customer-series-detail-page {
    .customer-series-head-box {
        position: sticky;
        top: 0;
        z-index: 100;
        background: #fff;
        padding-bottom: 11px;
        border-bottom: 1px solid #EBEEF5;
        box-sizing: border-box;
    }

    .customer-series-head {
        font-size: 18px;
        padding: 8px 0;
        margin-right: 8px;

    }
}
</style>
